import type { SideNavigationProps } from '@risk-smart/themed-cloudscape-components/side-navigation';
import { useState } from 'react';

import type { CountRenderer } from './Count';
import { navItemTypeReducer } from './navItemReducer';

// Derive a stable key from the item's identity (href, then text) rather than its
// array index. The nav list is assembled from many async permission/feature
// queries, so items appear and reorder as those resolve. With index keys React
// reuses a DOM node for whatever item now sits at that position — rewriting a
// link's href under a click in flight. Keying by identity keeps each link's DOM
// node tied to its route. Dividers and other non-interactive items that lack a
// stable identity fall back to the index; remounting/reordering those is safe.
const getNavItemKey = (
  item: SideNavigationProps.Item,
  index: number
): string => {
  if ('href' in item && item.href) {
    return `href:${item.href}`;
  }
  if ('text' in item && item.text) {
    return `${item.type}:${item.text}`;
  }

  return `${item.type}:${index}`;
};

export const NavItems = ({
  items,
  isChild,
  collapsed,
  renderCount,
}: {
  items: Readonly<SideNavigationProps.Item[]>;
  isChild?: boolean;
  collapsed?: boolean;
  renderCount?: CountRenderer;
}) => {
  const [expandedSection, setExpandedSection] = useState<string | null>(null);

  const onSectionClick = (section: string | null) => {
    if (expandedSection === section) {
      setExpandedSection(null);

      return;
    }

    setExpandedSection(section);
  };

  return items.map((item, index) => (
    <div
      key={getNavItemKey(item, index)}
      className={'box-border flex flex-col w-full'}
    >
      {navItemTypeReducer({
        index,
        items,
        item,
        isChild,
        collapsed,
        renderCount,
        expandedSection,
        onSectionClick,
      })}
    </div>
  ));
};
